// Tailored Vows — minimal theme interactions

// Mobile menu toggle
document.addEventListener("click", (e) => {
  const toggle = e.target.closest("[data-menu-toggle]");
  if (toggle) {
    const menu = document.querySelector("[data-mobile-menu]");
    if (menu) menu.classList.toggle("is-open");
  }
});

// Review carousel (dots)
document.querySelectorAll("[data-reviews]").forEach((root) => {
  const slides = root.querySelectorAll("[data-review]");
  const dots = root.querySelectorAll("[data-review-dot]");
  const show = (i) => {
    slides.forEach((s, n) => (s.hidden = n !== i));
    dots.forEach((d, n) => d.setAttribute("aria-selected", String(n === i)));
  };
  dots.forEach((dot, i) => dot.addEventListener("click", () => show(i)));
  if (slides.length) show(0);
});

// Product photo gallery (thumbnails swap the main image)
document.querySelectorAll("[data-product-gallery]").forEach((g) => {
  const main = g.querySelector(".product__gallery-main");
  if (!main) return;
  const thumbs = g.querySelectorAll("[data-thumb]");
  thumbs.forEach((btn) =>
    btn.addEventListener("click", () => {
      main.src = btn.dataset.thumb;
      thumbs.forEach((t) => t.classList.remove("is-active"));
      btn.classList.add("is-active");
    })
  );
});
